// @mui
import Card from '@mui/material/Card';
import { Box, Paper, TextField, Grid, Stack, Button, Typography, CircularProgress, Switch, FormControlLabel, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import CardContent from '@mui/material/CardContent';
// hooks
import { useEffect, useState, useRef } from 'react';
// components
import Iconify from 'src/components/iconify';
import { getRequest, postRequestForWebsite } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { handleErrorMessages } from 'src/services/fetching';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import { dataForHeroSection } from './mock';
import { useSelector } from 'react-redux';
import useHeroSection from 'src/hooks/use-homepage-data';

// ----------------------------------------------------------------------

export default function HeroSection() {
  const { enqueueSnackbar } = useSnackbar();
  const { fetchOnMount } = useHeroSection();
  const fileInputRef = useRef(null);
  const homePageData = useSelector((state) => state.website.homePage);
  const [loading, setLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [formData, setFormData] = useState({
    // Main Headlines
    mainHeadline: "",
    subtitle: "",
    highlights: [
      { text: "", color: "#27ae60" },
      { text: "", color: "#3498db" }
    ],
    subtitleHighlights: [
      { text: "", color: "#27ae60" },
    ],

    // Description Content
    mainDescription: "",
    descriptionHighlights: [
      { text: "", color: "#27ae60" },
    ],
    secondaryHeading: "",

    // Key Benefits
    features: [
      { title: "", description: "" },
      { title: "", description: "" },
      { title: "", description: "" },
      { title: "", description: "" },
      { title: "", description: "" }
    ],

    // Features Built to Support Construction Professionals
    featuresBuiltTitle: "",
    featureCountLabel: "",
    featureDescription: "",
    platformLabel: "",
    platformDescription: "",

    // Get Started Section
    getStartedTitle: "",
    freeTrialPoint: "",
    freeTrialColor: "#4CAF50",
    moneyBackPoint: "",
    moneyBackColor: "#4CAF50",
    pricingPoint: "",
    pricingColor: "#4CAF50",

    // CTA Buttons
    primaryButton: {
      text: "",
      link: "",
      color: "#27ae60"
    },
    secondaryButton: {
      text: "",
      link: "",
      color: "#3498db"
    },

    // Hero Image
    heroImage: null,
    heroImageUrl: "",

    // SEO Settings
    seoTitle: "",
    seoSubtitle: "",
    seoDescription: "",
    seoIndex: true,
    seoFollow: true,
    seoCanonicalUrl: "",

  });
  useEffect(() => {
    fetchOnMount();
  }, [fetchOnMount]);
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      ...homePageData?.home_page
    }));
  }, [homePageData])

  // const [formData, setFormData] = useState();


  // useEffect(() => {
  //   getHerSectionJson();
  // }, []);  // eslint-disable-line react-hooks/exhaustive-deps


  // const getHerSectionJson = async (page = 1) => {
  //   setGetLoading(true);

  //   try {
  //     const data = await getRequest(`${endpoints.admin_dashboard.website.home_page.hero_section}`);
  //     console.log("🚀 ~ getHerSectionJson ~ data:", data);
  //     console.log("🚀 ~ getHerSectionJson ~ data.data:", JSON.parse(data.web_page.json_data));
  //     let finnalRespone = JSON.parse(data.web_page.json_data)
  //     if (finnalRespone) {
  //       // Update form data with server data
  //       setFormData(prev => ({
  //         ...prev,
  //         ...finnalRespone
  //       }));

  //       // If there's a hero image URL in the response, set it as the preview
  //       // if (data.data.heroImageUrl) {
  //       //   setImagePreview(data.data.heroImageUrl);
  //       // }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching hero section data:", error);
  //     enqueueSnackbar({
  //       variant: 'error',
  //       message: 'Failed to load hero section data',
  //     });
  //   } finally {
  //     setGetLoading(false);
  //   }
  // };



  const updateFormData = (path, value) => {
    setFormData(prev => {
      const newData = { ...prev };
      const keys = path.split('.');
      let current = newData;

      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        // Create a new copy of the nested object to avoid mutating read-only properties
        current[key] = { ...current[key] };
        current = current[key];
      }
      current[keys[keys.length - 1]] = value;

      return newData;
    });
  };

  const addHighlight = () => {
    setFormData(prev => ({
      ...prev,
      highlights: [...prev.highlights, { text: "", color: "#3498db" }]
    }));
  };

  const removeHighlight = (index) => {
    setFormData(prev => ({
      ...prev,
      highlights: prev.highlights.filter((_, i) => i !== index)
    }));
  };

  const updateHighlight = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      highlights: prev.highlights.map((highlight, i) =>
        i === index ? { ...highlight, [field]: value } : highlight
      )
    }));
  };

  const addSubtitleHighlight = () => {
    setFormData(prev => ({
      ...prev,
      subtitleHighlights: [...prev.subtitleHighlights, { text: "", color: "#3498db" }]
    }));
  };

  const removeSubtitleHighlight = (index) => {
    setFormData(prev => ({
      ...prev,
      subtitleHighlights: prev.subtitleHighlights.filter((_, i) => i !== index)
    }));
  };

  const updateSubtitleHighlight = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      subtitleHighlights: prev.subtitleHighlights.map((highlight, i) =>
        i === index ? { ...highlight, [field]: value } : highlight
      )
    }));
  };

  const addDescriptionHighlight = () => {
    setFormData(prev => ({
      ...prev,
      descriptionHighlights: [...prev.descriptionHighlights, { text: "", color: "#3498db" }]
    }));
  };

  const removeDescriptionHighlight = (index) => {
    setFormData(prev => ({
      ...prev,
      descriptionHighlights: prev.descriptionHighlights.filter((_, i) => i !== index)
    }));
  };

  const updateDescriptionHighlight = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      descriptionHighlights: prev.descriptionHighlights.map((highlight, i) =>
        i === index ? { ...highlight, [field]: value } : highlight
      )
    }));
  };

  const addFeature = () => {
    setFormData(prev => ({
      ...prev,
      features: [...prev.features, { title: "", description: "" }]
    }));
  };

  const removeFeature = (index) => {
    setFormData(prev => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index)
    }));
  };

  // Hero Image handling
  // const handleImageUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     // Check file size (limit to 2MB)
  //     if (file.size > 2 * 1024 * 1024) {
  //       enqueueSnackbar({
  //         variant: 'error',
  //         message: 'Image size exceeds 2MB limit',
  //       });
  //       return;
  //     }

  //     // Create a preview URL for the image
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       setImagePreview(e.target.result);

  //       // Update form data with the file for submission
  //       setFormData(prev => ({
  //         ...prev,
  //         heroImage: file
  //       }));
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  // const triggerFileInput = () => {
  //   fileInputRef.current.click();
  // };

  const updateFeature = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      features: prev.features.map((feature, i) =>
        i === index ? { ...feature, [field]: value } : feature
      )
    }));
  };

  const handleSave = async () => {
    setLoading(true);

    try {
      // Create a FormData object for file uploads
      const formDataToSend = new FormData();

      // Append all form data
      Object.entries(formData).forEach(([key, value]) => {
        // Skip heroImage as we'll handle it separately
        if (key !== 'heroImage') {
          // Handle nested objects like primaryButton and secondaryButton
          if (typeof value === 'object' && value !== null && !(value instanceof File)) {
            formDataToSend.append(key, JSON.stringify(value));
          } else {
            formDataToSend.append(key, value);
          }
        }
      });

      // Append the hero image if it exists
      if (formData.heroImage) {
        formDataToSend.append('heroImage', formData.heroImage);
      }

      // Make sure heroImageUrl is included in the submission
      if (formData.heroImageUrl) {
        formDataToSend.append('heroImageUrl', formData.heroImageUrl);
      }

      const response = await postRequestForWebsite(
        endpoints.admin_dashboard.website.home_page.hero_section,
        // formDataToSend,
        // dataForHeroSection,
        {
          attributes: {
            ...JSON.parse(JSON.stringify(homePageData)),
            home_page: formData
          }
        },
        true
      );

      if (response.metadata?.success) {
        enqueueSnackbar({
          variant: 'success',
          message: response.metadata.message,
        });
      } else {
        handleErrorMessages(response.message || 'An error occurred.');
      }
    } catch (err) {
      console.error('Error:', err);
      handleErrorMessages(err.message || 'Submission failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h4" paragraph>
          SEO Setting
        </Typography>

        {/* SEO Settings Accordion */}
        <Accordion
          defaultExpanded={false}
          sx={{
            mb: 5,
            '&:before': {
              display: 'none',
            },
            boxShadow: 1,
            borderRadius: 1,
          }}
        >
          <AccordionSummary
            expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
            sx={{
              bgcolor: 'background.neutral',
              minHeight: 56,
              '&.Mui-expanded': {
                minHeight: 56,
              },
              '& .MuiAccordionSummary-content': {
                margin: '12px 0',
              },
            }}
          >
            <Stack direction="row" alignItems="center">
              <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
              <Typography variant="h6">SEO Meta Information</Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ p: 3 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Meta Title</Typography>
                  <TextField
                    fullWidth
                    value={formData.seoTitle}
                    onChange={(e) => updateFormData('seoTitle', e.target.value)}
                    placeholder="Enter Meta title (recommended: 50-60 characters)"
                    helperText={`${formData.seoTitle.length}/60 characters`}
                    inputProps={{ maxLength: 60 }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Meta Subtitle</Typography>
                  <TextField
                    fullWidth
                    value={formData.seoSubtitle}
                    onChange={(e) => updateFormData('seoSubtitle', e.target.value)}
                    placeholder="Enter Meta subtitle"
                  />
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Meta Description</Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    value={formData.seoDescription}
                    onChange={(e) => updateFormData('seoDescription', e.target.value)}
                    placeholder="Enter meta description (recommended: 150-260 characters)"
                    helperText={`${formData.seoDescription.length}/160 characters`}
                    inputProps={{ maxLength: 260 }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Canonical URL</Typography>
                  <TextField
                    fullWidth
                    value={formData.seoCanonicalUrl}
                    onChange={(e) => updateFormData('seoCanonicalUrl', e.target.value)}
                    placeholder="https://example.com/canonical-url"
                    helperText="Optional: Specify canonical URL to avoid duplicate content"
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Robot Settings</Typography>
                  <Stack direction="column" spacing={2}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData.seoIndex}
                          onChange={(e) => updateFormData('seoIndex', e.target.checked)}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="body2">
                          Allow search engines to index this page
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData.seoFollow}
                          onChange={(e) => updateFormData('seoFollow', e.target.checked)}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="body2">
                          Allow search engines to follow links on this page
                        </Typography>
                      }
                    />
                  </Stack>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    Control how search engines crawl and index this page
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Typography variant="h4" paragraph>
          Hero Section
        </Typography>

        {/* Main Headlines Section */}
        <Box sx={{ mb: 5, pb: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Main Headlines</Typography>
          </Stack>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Main Headline (H1)</Typography>
            <TextField
              fullWidth
              value={formData.mainHeadline}
              onChange={(e) => updateFormData('mainHeadline', e.target.value)}
              placeholder="Enter main headline"
              helperText="This is your primary headline - keep it under 60 characters for best impact"
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Highlighted Words in Headline</Typography>
            <Paper variant="outlined" sx={{ p: 3, bgcolor: 'background.neutral' }}>
              {formData.highlights.map((highlight, index) => (
                <Stack key={index} direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }} sx={{ mb: 2 }}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Word to highlight"
                    value={highlight.text}
                    onChange={(e) => updateHighlight(index, 'text', e.target.value)}
                  />
                  <TextField
                    type="color"
                    size="small"
                    value={highlight.color}
                    onChange={(e) => updateHighlight(index, 'color', e.target.value)}
                    sx={{ width: 100 }}
                  />
                  <Button
                    color="error"
                    variant="contained"
                    size="small"
                    startIcon={<Iconify icon="mingcute:close-line" />}
                    onClick={() => removeHighlight(index)}
                  >
                    Remove
                  </Button>
                </Stack>
              ))}
              <Button
                color="success"
                variant="contained"
                startIcon={<Iconify icon="mingcute:add-line" />}
                onClick={addHighlight}
              >
                Add Highlight
              </Button>
            </Paper>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Subtitle (H2)</Typography>
            <TextField
              fullWidth
              value={formData.subtitle}
              onChange={(e) => updateFormData('subtitle', e.target.value)}
              placeholder="Enter subtitle"
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Highlighted Words in Subtitle</Typography>
            <Paper variant="outlined" sx={{ p: 3, bgcolor: 'background.neutral' }}>
              {formData.subtitleHighlights.map((highlight, index) => (
                <Stack key={index} direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }} sx={{ mb: 2 }}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Word to highlight in subtitle"
                    value={highlight.text}
                    onChange={(e) => updateSubtitleHighlight(index, 'text', e.target.value)}
                  />
                  <TextField
                    type="color"
                    size="small"
                    value={highlight.color}
                    onChange={(e) => updateSubtitleHighlight(index, 'color', e.target.value)}
                    sx={{ width: 100 }}
                  />
                  <Button
                    color="error"
                    variant="contained"
                    size="small"
                    startIcon={<Iconify icon="mingcute:close-line" />}
                    onClick={() => removeSubtitleHighlight(index)}
                  >
                    Remove
                  </Button>
                </Stack>
              ))}
              <Button
                color="success"
                variant="contained"
                startIcon={<Iconify icon="mingcute:add-line" />}
                onClick={addSubtitleHighlight}
              >
                Add Subtitle Highlight
              </Button>
            </Paper>
          </Box>
        </Box>

        {/* Description Section */}
        <Box sx={{ mb: 5, pb: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Description Content</Typography>
          </Stack>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Main Description</Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={formData.mainDescription}
              onChange={(e) => updateFormData('mainDescription', e.target.value)}
              placeholder="Enter your main description"
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Highlighted Words in Description</Typography>
            <Paper variant="outlined" sx={{ p: 3, bgcolor: 'background.neutral' }}>
              {formData.descriptionHighlights.map((highlight, index) => (
                <Stack key={index} direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }} sx={{ mb: 2 }}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Word to highlight in description"
                    value={highlight.text}
                    onChange={(e) => updateDescriptionHighlight(index, 'text', e.target.value)}
                  />
                  <TextField
                    type="color"
                    size="small"
                    value={highlight.color}
                    onChange={(e) => updateDescriptionHighlight(index, 'color', e.target.value)}
                    sx={{ width: 100 }}
                  />
                  <Button
                    color="error"
                    variant="contained"
                    size="small"
                    startIcon={<Iconify icon="mingcute:close-line" />}
                    onClick={() => removeDescriptionHighlight(index)}
                  >
                    Remove
                  </Button>
                </Stack>
              ))}
              <Button
                color="success"
                variant="contained"
                startIcon={<Iconify icon="mingcute:add-line" />}
                onClick={addDescriptionHighlight}
              >
                Add Description Highlight
              </Button>
            </Paper>
          </Box>
        </Box>

        {/* Features List Section */}
        <Box sx={{ mb: 5, pb: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Key Benefits List</Typography>
          </Stack>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Secondary Heading</Typography>
            <TextField
              fullWidth
              value={formData.secondaryHeading}
              onChange={(e) => updateFormData('secondaryHeading', e.target.value)}
              placeholder="Enter secondary heading"
            />
          </Box>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Benefit Points</Typography>
            <Paper variant="outlined" sx={{ p: 3 }}>
              {formData.features.map((feature, index) => (
                <Stack key={index} direction="column" spacing={2} sx={{ mb: 3, p: 2, bgcolor: 'background.neutral', borderRadius: 1 }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle2">Benefit Point {index + 1}</Typography>
                    <Button
                      color="error"
                      variant="contained"
                      size="small"
                      startIcon={<Iconify icon="mingcute:close-line" />}
                      onClick={() => removeFeature(index)}
                    >
                      Remove
                    </Button>
                  </Stack>
                  <TextField
                    fullWidth
                    size="small"
                    label="Title"
                    value={feature.title}
                    onChange={(e) => updateFeature(index, 'title', e.target.value)}
                    placeholder="Example: Accounting & Financial Tools"
                    sx={{ mb: 1 }}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={2}
                    label="Description"
                    value={feature.description}
                    onChange={(e) => updateFeature(index, 'description', e.target.value)}
                    placeholder="Example: Handle budgets, invoices, and daily expenses effortlessly."
                  />
                </Stack>
              ))}
              <Button
                color="success"
                variant="contained"
                startIcon={<Iconify icon="mingcute:add-line" />}
                onClick={addFeature}
              >
                Add Benefit Point
              </Button>
            </Paper>
          </Box>
        </Box>

        {/* Features Built Section */}
        <Box sx={{ mb: 5, pb: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Features Built to Support Construction Professionals</Typography>
          </Stack>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Section Title</Typography>
            <TextField
              fullWidth
              value={formData.featuresBuiltTitle || "Features Built to Support Construction Professionals"}
              onChange={(e) => updateFormData('featuresBuiltTitle', e.target.value)}
              placeholder="Enter section title"
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Powerful Features</Typography>
            <TextField
              fullWidth
              label="Feature Count Label"
              value={formData.featureCountLabel || "500+ Powerful Features:"}
              onChange={(e) => updateFormData('featureCountLabel', e.target.value)}
              placeholder="Example: 500+ Powerful Features:"
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              multiline
              rows={2}
              label="Feature Description"
              value={formData.featureDescription || "Risk, Project & Task Management, purchase orders, work orders"}
              onChange={(e) => updateFormData('featureDescription', e.target.value)}
              placeholder="Describe the features"
              sx={{ mb: 2 }}
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Multi-Platform Accessibility</Typography>
            <TextField
              fullWidth
              label="Platform Label"
              value={formData.platformLabel || "Multi-Platform Accessibility:"}
              onChange={(e) => updateFormData('platformLabel', e.target.value)}
              placeholder="Example: Multi-Platform Accessibility:"
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Platform Description"
              value={formData.platformDescription || "Use on iOS, Android, or Desktop."}
              onChange={(e) => updateFormData('platformDescription', e.target.value)}
              placeholder="Describe the platforms"
            />
          </Box>
        </Box>

        {/* Get Started Section */}
        <Box sx={{ mb: 5, pb: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Get Started With Ezelogs Today</Typography>
          </Stack>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Section Title</Typography>
            <TextField
              fullWidth
              value={formData.getStartedTitle || "Get Started With Ezelogs Today"}
              onChange={(e) => updateFormData('getStartedTitle', e.target.value)}
              placeholder="Enter section title"
            />
          </Box>

          <Typography variant="subtitle2" sx={{ mb: 2 }}>Call-to-Action Points</Typography>



          <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
            <Stack spacing={3}>
              <Stack direction="row" spacing={2} alignItems="center">
                <TextField
                  fullWidth
                  label="Free Trial Point"
                  value={formData.freeTrialPoint || "Free Trial, No Strings Attached: Explore Ezelogs without upfront commitment."}
                  onChange={(e) => updateFormData('freeTrialPoint', e.target.value)}
                  placeholder="Free trial description"
                />
                <TextField
                  sx={{ width: 100 }}
                  label="Icon Color"
                  type="color"
                  value={formData.freeTrialColor || "#4CAF50"}
                  onChange={(e) => updateFormData('freeTrialColor', e.target.value)}
                />
              </Stack>

              <Stack direction="row" spacing={2} alignItems="center">
                <TextField
                  fullWidth
                  label="Money-back Guarantee"
                  value={formData.moneyBackPoint || "90-Day Refund Guarantee: If it doesn't meet your needs, get your money back."}
                  onChange={(e) => updateFormData('moneyBackPoint', e.target.value)}
                  placeholder="Money-back guarantee description"
                />
                <TextField
                  sx={{ width: 100 }}
                  label="Icon Color"
                  type="color"
                  value={formData.moneyBackColor || "#4CAF50"}
                  onChange={(e) => updateFormData('moneyBackColor', e.target.value)}
                />
              </Stack>

              <Stack direction="row" spacing={2} alignItems="center">
                <TextField
                  fullWidth
                  label="Pricing Options"
                  value={formData.pricingPoint || "Flexible Pricing Options: Affordable plans to suit projects of all sizes."}
                  onChange={(e) => updateFormData('pricingPoint', e.target.value)}
                  placeholder="Pricing options description"
                />
                <TextField
                  sx={{ width: 100 }}
                  label="Icon Color"
                  type="color"
                  value={formData.pricingColor || "#4CAF50"}
                  onChange={(e) => updateFormData('pricingColor', e.target.value)}
                />
              </Stack>
            </Stack>
          </Paper>
        </Box>


        {/* Call-to-Action Buttons */}
        <Box sx={{ mb: 5, pb: 3, }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Call-to-Action Buttons</Typography>
          </Stack>

          <Grid container spacing={3}>
            {/* Primary Button */}
            <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 2 }}>Primary Button</Typography>
                <Stack spacing={3}>
                  <TextField
                    fullWidth
                    label="Button Text"
                    value={formData.primaryButton.text}
                    onChange={(e) => updateFormData('primaryButton.text', e.target.value)}
                  />
                  <TextField
                    fullWidth
                    label="Button Link"
                    value={formData.primaryButton.link}
                    onChange={(e) => updateFormData('primaryButton.link', e.target.value)}
                    placeholder="Enter URL or path"
                  />
                  <TextField
                    fullWidth
                    label="Button Color"
                    type="color"
                    value={formData.primaryButton.color}
                    onChange={(e) => updateFormData('primaryButton.color', e.target.value)}
                    sx={{ '& input': { height: 40 } }}
                  />
                </Stack>
              </Paper>
            </Grid>

            {/* Secondary Button */}
            <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 2 }}>Secondary Button</Typography>
                <Stack spacing={3}>
                  <TextField
                    fullWidth
                    label="Button Text"
                    value={formData.secondaryButton.text}
                    onChange={(e) => updateFormData('secondaryButton.text', e.target.value)}
                  />
                  <TextField
                    fullWidth
                    label="Button Link"
                    value={formData.secondaryButton.link}
                    onChange={(e) => updateFormData('secondaryButton.link', e.target.value)}
                    placeholder="Enter URL or path"
                  />
                  <TextField
                    fullWidth
                    label="Button Color"
                    type="color"
                    value={formData.secondaryButton.color}
                    onChange={(e) => updateFormData('secondaryButton.color', e.target.value)}
                    sx={{ '& input': { height: 40 } }}
                  />
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </Box>




        {/* Hero Image Section */}
        <Box sx={{ mb: 5, pb: 3 }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1, mr: 1.5 }} />
            <Typography variant="h6">Hero Image/Mockup</Typography>
          </Stack>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Hero Image URL</Typography>
            <Paper
              variant="outlined"
              sx={{
                p: 4,
                borderRadius: 1,
                bgcolor: 'background.neutral'
              }}
            >
              <TextField
                fullWidth
                label="Image URL"
                placeholder="Enter the URL of your hero image"
                value={formData.heroImageUrl || ""}
                onChange={(e) => updateFormData('heroImageUrl', e.target.value)}
                helperText="Enter a valid image URL (e.g., https://example.com/image.jpg)"
                sx={{ mb: 2 }}
              />

              {formData.heroImageUrl && (
                <Box
                  sx={{
                    width: '100%',
                    maxWidth: 400,
                    height: 200,
                    mx: 'auto',
                    mt: 2,
                    bgcolor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    position: 'relative'
                  }}
                >
                  <Box
                    component="img"
                    src={formData.heroImageUrl}
                    alt="Hero Image Preview"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      position: 'absolute',
                      display: 'none',
                      color: 'text.disabled',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%'
                    }}
                  >
                    Invalid image URL
                  </Typography>
                </Box>
              )}
            </Paper>
          </Box>
        </Box>

        {/* Action Buttons */}
        <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
          {/* <Button
            variant="outlined"
            color="inherit"
            onClick={() => handleSave(true)}
          >
            Save as Draft
          </Button> */}
          <LoadingButton
            loading={loading}
            variant="contained"
            color="primary"
            onClick={handleSave}
            startIcon={<Iconify icon="eva:save-fill" />}
          >
            Update
          </LoadingButton>
        </Stack>
      </CardContent>
    </Card>
  );
}
